/* eslint-disable array-callback-return */
// @ts-nocheck
/* eslint-disable prefer-destructuring */
/* eslint-disable no-underscore-dangle */
import React, { useEffect } from 'react';
import { useRouter } from 'next/router';
import { GetServerSidePropsContext } from 'next';
import qs from 'qs';
import { getPlaces } from '@/utils/flightDeeplinkAirport';
import { transformAreaData } from '@/utils/transformAreaData';
import {
  get, isEmpty,
} from 'lodash';

import { addDays, format } from 'date-fns';
import { monthYears } from '@/utils/monthYears';
import { getAccessToken } from '@/pages/api/getToken';
import { resetSortingFlight } from '@/slices/sortingFlight/sortingFlightSlice';
import CompanyPageContainer, { AIRLINES } from '@/containers/CompanyPage';
import RouteToCityPageContainer from '@/containers/RouteToCityPage';
import RouteCompanyToCityContainer from '@/containers/RouteCompanyToCity';
import RouteCompanyCityToCityContainer from '@/containers/RouteCompanyCityToCity';
import RoutePageContainer from '@/containers/RoutePage';
import { DEFAULT_SEO_FROM, DEFAULT_SEO_TO } from '@/components/CompanyPage/constants';
import dynamic from 'next/dynamic';
import { useCheckIsMobile } from '@/utils/hooks/use-check-is-mobile';
import { getRangeCountTet } from '@/components/RoutePage/SectionManager/utils';
import { addImagesPromotion } from '@/slices/strapi/slices/strapiSlice';
import { useDispatch } from 'react-redux';
import {
  addFallbackPoints, addHomePoints, clearHomePoints, clearPoints,
} from '@/slices/area/slices/searchFlightFormSlice';
import { resetFilter } from '@/slices/filterFlight/filterFlightSlice';

const RoutePageDesktop = dynamic(() => import('./desktop'));

export const airlineMapping = {
  'vietnam-airlines': 'VN',
  'vietjet-air': 'VJ',
  'bamboo-airways': 'QH',
  'vietravel-airlines': 'VU',
  'pacific-airlines': 'BL',
};
let selectedCompany = '';
const RoutePage = ({
  startPoint, endPoint, countResult, countSeoResult, countSeoAllResult, countSeoReturnResult, company, flightResult, countSeoTetResult, countTetResult, imagePromotion,
}: any) => {
  const router = useRouter();
  const dispatch = useDispatch();
  const { query: { slug } } = router;
  const isCompanyCityToCity = Object.keys(airlineMapping).some((_company: string) => {
    if (slug?.includes(_company)) {
      selectedCompany = _company;
      return true;
    }
    return false;
  });
  useEffect(() => {
    setTimeout(() => {
      dispatch(addFallbackPoints());
      dispatch(resetFilter());
      dispatch(resetSortingFlight());

      if (slug) {
        if ((!company && isEmpty(startPoint) && !isEmpty(endPoint))
    || (company && !isEmpty(endPoint) && isEmpty(startPoint))) {
          dispatch(clearPoints({ type: 'from' }));
          dispatch(clearHomePoints({ type: 'from' }));
        } else if (company && isEmpty(endPoint)) {
          dispatch(clearPoints({ type: 'all' }));
        }
      }
      if (!isEmpty(startPoint)) {
        dispatch(
          addHomePoints({
            type: 'from',
            data: startPoint,
          }),
        );
      }
      if (!isEmpty(endPoint)) {
        dispatch(
          addHomePoints({
            type: 'to',
            data: endPoint,
          }),
        );
      }
    }, 1000);
    if (imagePromotion) {
      dispatch(addImagesPromotion(imagePromotion));
    }
  }, []);
  // Dynamic does not work with SSR, will return client rendered pages
  // if (slug) {
  // if (!company && isEmpty(startPoint) && !isEmpty(endPoint)) {
  //   Component = dynamic(import('@/containers/RouteToCityPage'));
  // } else if (company && !isEmpty(endPoint) && isEmpty(startPoint)) {
  //   Component = dynamic(import('@/containers/RouteCompanyToCity'));
  // } else if (isCompanyCityToCity) {
  //   Component = dynamic(import('@/containers/RouteCompanyCityToCity'));
  // } else {
  //   Component = dynamic(import('@/containers/RoutePage'));
  // }
  // }
  const isMobile = useCheckIsMobile();
  if (!isMobile) {
    return (
      <RoutePageDesktop
        startPoint={startPoint}
        endPoint={endPoint}
        countResult={countResult}
        countSeoResult={countSeoResult}
        countTetResult={countTetResult}
        countSeoTetResult={countSeoTetResult}
        countSeoAllResult={countSeoAllResult}
        countSeoReturnResult={countSeoReturnResult}
        company={company}
        flightResult={flightResult}
      />
    );
  }

  if (slug) {
    if (company && isEmpty(endPoint)) {
      return (
        <CompanyPageContainer
          company={selectedCompany}
          countSeoTetResult={countSeoTetResult}
          countSeoResult={countSeoResult}
        />
      );
    }
    if (!isCompanyCityToCity && isEmpty(startPoint) && !isEmpty(endPoint)) {
      return (
        <RouteToCityPageContainer
          startPoint={isEmpty(startPoint) ? null : startPoint}
          company={selectedCompany}
          endPoint={endPoint}
          company2={company}
          countResult={countResult}
          countSeoTetResult={countSeoTetResult}
          countSeoResult={countSeoResult}
          countTetResult={countTetResult}
          countSeoAllResult={countSeoAllResult}
          countSeoReturnResult={countSeoReturnResult}
          flightResult={flightResult}
        />
      );
    }

    if (company && !isEmpty(endPoint) && isEmpty(startPoint)) {
      return (
        <RouteCompanyToCityContainer
          startPoint={isEmpty(startPoint) ? null : startPoint}
          company={selectedCompany}
          endPoint={endPoint}
          company2={company}
          countSeoTetResult={countSeoTetResult}
          countResult={countResult}
          countSeoResult={countSeoResult}
          countTetResult={countTetResult}
          countSeoAllResult={countSeoAllResult}
          countSeoReturnResult={countSeoReturnResult}
          flightResult={flightResult}
        />
      );
    }
    if (isCompanyCityToCity) {
      return (
        <RouteCompanyCityToCityContainer
          startPoint={isEmpty(startPoint) ? null : startPoint}
          company={selectedCompany}
          endPoint={endPoint}
          company2={company}
          countResult={countResult}
          countTetResult={countTetResult}
          countSeoTetResult={countSeoTetResult}
          countSeoResult={countSeoResult}
          countSeoAllResult={countSeoAllResult}
          countSeoReturnResult={countSeoReturnResult}
          flightResult={flightResult}
        />
      );
    }
    return (
      <RoutePageContainer
        startPoint={isEmpty(startPoint) ? null : startPoint}
        company={selectedCompany}
        endPoint={endPoint}
        company2={company}
        countResult={countResult}
        countSeoTetResult={countSeoTetResult}
        countTetResult={countTetResult}
        countSeoResult={countSeoResult}
        countSeoAllResult={countSeoAllResult}
        countSeoReturnResult={countSeoReturnResult}
        flightResult={flightResult}
      />
    );
  }
  return <div />;
};
const hcmData = {
  full_name: 'Sài Gòn',
  name: 'Sài Gòn',
  name_token: 'Sài Gòn',
  state_name: 'Sài Gòn',
};
export async function getServerSideProps(context: GetServerSidePropsContext) {
  context.res.setHeader(
    'Cache-Control',
    'public, s-maxage=60, stale-while-revalidate=120',
  );

  let startPoint = {};
  let endPoint = {};
  const ES_BASE_URL = process.env.APP_ENV === 'production' ? 'https://es-vxr-c01.vexere.com' : 'https://uat-es-vxr-c01.vexere.net';
  const route = getPlaces((context.req.url || '') as string);
  if (route.fromAreaId) {
    const startPointRes = await fetch(`${ES_BASE_URL}/area/_doc/${route.fromAreaId}`);
    let from = (await startPointRes.json())._source;
    if (route.fromAreaId === 29) {
      from = {
        ...from,
        ...hcmData,
      };
    }
    startPoint = transformAreaData([from])[0];
  }
  if (route.toAreaId) {
    const endPointRes = await fetch(`${ES_BASE_URL}/area/_doc/${route.toAreaId}`);
    let to = (await endPointRes.json())._source;
    endPoint = transformAreaData([to])[0];
    if (route.toAreaId === 29) {
      to = {
        ...to,
        ...hcmData,
      };
    }
  }
  const fromAirportCode = get(startPoint, 'airports[0].airportCode');
  const toAirportCode = get(endPoint, 'airports[0].airportCode');
  const filterFrom = fromAirportCode ? [fromAirportCode] : [];
  const filterTo = toAirportCode ? [toAirportCode] : [];
  let filterAirline = route.company && AIRLINES[route.company] ? [AIRLINES[route.company].type] : [];
  if (filterAirline.includes('VN')) {
    filterAirline.push('BL');
  } else if (isEmpty(filterAirline)) {
    filterAirline = ['VN', 'VJ', 'QH', 'BL', 'VU'];
  }
  let countSeoFrom = filterFrom;
  let countSeoTo = filterTo;
  if (!(route.fromAreaId || route.toAreaId)) {
    countSeoFrom = DEFAULT_SEO_FROM;
    countSeoTo = DEFAULT_SEO_TO;
  }
  const countSeoObj = {
    from: countSeoFrom,
    to: countSeoTo,
    date_range: {
      min: format(new Date(), 'yyyy-MM-dd'),
      max: format(addDays(new Date(), 45), 'yyyy-MM-dd'),
    },
    quantity: 1,
    // ...(!isEmpty(filterAirline) ? { airline: filterAirline } : {}),
  };
  const { startDate, endDate } = getRangeCountTet();

  const countTetObj = {
    from: countSeoFrom,
    to: countSeoTo,
    date_range: {
      min: startDate,
      max: endDate,
    },
    ...(!isEmpty(filterAirline) ? { airline: filterAirline } : {}),
    is_count_tet_price: 1,
    quantity: 1,
  };

  const countTetSeoObj = {
    from: countSeoFrom,
    to: countSeoTo,
    date_range: {
      min: format(new Date('2025-01-01'), 'yyyy-MM-dd'),
      max: format(new Date('2025-01-31'), 'yyyy-MM-dd'),
    },
    ...(!isEmpty(filterAirline) ? { airline: filterAirline } : {}),
    quantity: 1,
  };

  const countSeoAllObj = JSON.parse(JSON.stringify(countSeoObj));
  delete countSeoAllObj.airline;
  const countSeoReturnObj = Object.assign(JSON.parse(JSON.stringify(countSeoObj)));
  countSeoReturnObj.from = filterTo;
  countSeoReturnObj.to = filterFrom;
  const countObj = {
    from: filterFrom,
    to: filterTo,
    month_years: monthYears(),
    quantity: 1,
    // ...(!isEmpty(filterAirline) ? { airline: filterAirline } : {}),
    page: 1,
    size: 10,
  };
  const defaultPageSize = {
    page: 1,
    size: 10,
  };
  // const flightObj = {
  //   from: filterFrom,
  //   to: filterTo,
  //   date: format(new Date(), 'yyyy-MM-dd'),
  //   ...(!isEmpty(filterAirline) ? { airline: filterAirline } : {}),
  //   quantity: 1,
  //   sort: 'fare:asc',
  //   page: 1,
  //   pagesize: 10,
  // };
  const tokenObj = getAccessToken();
  const headers = {
    Authorization: `Bearer ${tokenObj.access_token}`,
    'Content-Type': 'application/x-www-form-urlencoded',
  };

  const countRequest = `${process.env.VROUTE_BASE_URL}/v2/route/flight/count?${qs.stringify({
    filter: {
      ...countObj,
      ...defaultPageSize,
    },
  })}`;
  const countSeoRequest = `${process.env.VROUTE_BASE_URL}/v2/route/flight/count_seo_route?${qs.stringify({
    filter: {
      ...countSeoObj,
      ...defaultPageSize,
    },
  })}`;

  const countTetRequest = `${process.env.VROUTE_BASE_URL}/v2/route/flight/count?${qs.stringify({
    filter: {
      ...countTetObj,
      ...defaultPageSize,
    },
  })}`;

  const countSeoTetRequest = `${process.env.VROUTE_BASE_URL}/v2/route/flight/count_seo_route?${qs.stringify({
    filter: {
      ...countTetSeoObj,
      ...defaultPageSize,
    },
  })}`;

  const countSeoAllRequest = `${process.env.VROUTE_BASE_URL}/v2/route/flight/count_seo_route?${qs.stringify({
    filter: {
      ...countSeoAllObj,
      ...defaultPageSize,
    },
  })}`;
  const countSeoReturnRequest = `${process.env.VROUTE_BASE_URL}/v2/route/flight/count_seo_route?${qs.stringify({
    filter: {
      ...countSeoReturnObj,
      ...defaultPageSize,
    },
  })}`;
  // const flightRequest = `${process.env.VROUTE_BASE_URL}/v2/route/flight?${qs.stringify({
  //   filter: {
  //     ...flightObj,
  //   },
  // })}`;
  const countResult = fromAirportCode ? await fetch(countRequest, { headers }).then((rps) => rps.json()).then((rps) => rps.data) : [];
  const countSeoResult = (fromAirportCode || countSeoFrom) ? await fetch(countSeoRequest, { headers }).then((rps) => rps.json()).then((rps) => rps.data) : {};
  const countSeoAllResult = fromAirportCode && !isEmpty(filterAirline) ? await fetch(countSeoAllRequest, { headers }).then((rps) => rps.json()).then((rps) => rps.data) : {};
  const countSeoReturnResult = fromAirportCode ? await fetch(countSeoReturnRequest, { headers }).then((rps) => rps.json()).then((rps) => rps.data) : {};
  // const flightResult = await fetch(flightRequest, { headers }).then((rps) => rps.json()).then((rps) => rps.data);
  const countSeoTetResult = fromAirportCode ? await fetch(countSeoTetRequest, { headers }).then((rps) => rps.json()).then((rps) => rps.data) : {};
  const countTetResult = fromAirportCode ? await fetch(countTetRequest, { headers }).then((rps) => rps.json()).then((rps) => rps.data) : {};

  const goyoloSeoHeaders = {
    Authorization: `Bearer ${process.env.VCMS_TOKEN}`,
    'Content-Type': 'application/x-www-form-urlencoded',
  };

  let imagePromotion;
  try {
    const goyoloSeoFlexiData = `${process.env.VCMS_BASE_URL}/api/flexi-entities?filters[slug][$eq]=banner-discount&populate=deep`;
    const goyoloFlexiArray = await fetch(goyoloSeoFlexiData, { headers: goyoloSeoHeaders }).then((rps) => rps.json()).then((rps) => rps.data) as GoyoloFlexiEntityResponse[];
    imagePromotion = goyoloFlexiArray?.[0]?.attributes?.jsonAttributes?.[0]?.value;
  } catch (err) {
    console.log(err);
  }
  return {
    props: {
      startPoint,
      endPoint,
      countResult,
      countSeoResult,
      countTetResult,
      countSeoTetResult,
      countSeoAllResult,
      countSeoReturnResult,
      flightResult: {},
      imagePromotion: imagePromotion || null,
      ...(!isEmpty(filterAirline) && filterAirline.length !== 4 ? { company: filterAirline[0] } : {}),
    },
  };
}
export default RoutePage;
